module.exports = __webpack_public_path__ + "img/229b344.jpg";